import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {FaGlobe} from "react-icons/fa";

function LanguageSwitch(props){

    const { t, i18n } = useTranslation()

    const [language, setLetnguage] = useState(i18n.language);

    const changeLanguage = (event) => {
        i18n.changeLanguage(event.target.value)
        setLetnguage(event.target.value);
        console.log('language: ' + event.target.value);
    }

    return (<div>
        <div id="lang-switch" content={''} className={'p-2 pt-1 pb-1'}>
            <div onChange={changeLanguage}>
                <ul className={'list-unstyled d-flex flex-column-'}>
                    {
                        i18n.language !== 'en' && <li className={'p- mt-3 m-1'}>
                            <FaGlobe color={'gray'} />
                            <label className="radio-img p-11 flag-language bg-transparent">
                                <input type="radio" value="en" name="language"/>
                                {/*<img src="/assets/lang/images/uk.png" alt="English" width="16"/>*/}
                                <span className={'text-dark'}>🇬🇧</span>
                            </label>
                        </li>
                    }
                    {
                        i18n.language !== 'ua' && <li className={'p- mt-3 m-1'}>
                            <FaGlobe color={'gray'} />
                            <label className="radio-img p-11 flag-language bg-transparent">
                                <input type="radio" value="ua" name="language"/>
                                {/*<img src="/assets/lang/images/ua.png" alt="Ukraine" width="16"/>*/}
                                <span className={props.color}>🇺🇦</span>
                            </label>
                        </li>
                    }


                </ul>
            </div>
        </div>
    </div>);
}

export default LanguageSwitch;
